import type { Theme } from '@mui/material/styles'

type Owner = { theme: Theme }

const Chip = () => ({
  MuiChip: {
    styleOverrides: {
      root: {
        height: 28,
        '&.MuiChip-rounded': { borderRadius: 4 },
        /**
         * Escape da caixa alta da casa. O chip do design system e uppercase, o
         * que serve para rotulo curto ("PENDENTE"), mas destroi citacao
         * normativa: "Res. ARSAL 137/2014, art. 22, II" nao pode virar
         * "RES. ARSAL 137/2014, ART. 22, II" num documento com efeito juridico.
         * Chips que carregam texto corrido usam esta classe.
         */
        '&.chip-prosa .MuiChip-label': { textTransform: 'none' as const },
      },
      sizeSmall: { height: 24 },
      outlined: ({ theme }: Owner) => ({
        '&.MuiChip-colorDefault': { borderColor: `rgba(${theme.palette.customColors.mainRgb}, 0.22)` },
      }),
      deleteIcon: { width: 18, height: 18 },
      label: ({ theme }: Owner) => ({
        textTransform: 'uppercase' as const,
        padding: theme.spacing(0, 2.5),
      }),
    },
  },
})

export default Chip
